import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {

    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'salesae_name', 'salesae_id', 'CustName', 'customer_id', 'customer_group', 'nomor', 'tgl1', 'tgl2',  'status', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerysales${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    listbinder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'salesae_name', 'salesae_id', 'CustName', 'customer_id', 'customer_group', 'nomor', 'tgl1', 'tgl2',  'status', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerysales/listbinder${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },      
    listline(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'salesae_name', 'salesae_id', 'CustName', 'customer_id', 'customer_group', 'nomor', 'tgl1', 'tgl2',  'status', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerysales/listline${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("/bakerysales", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savebinder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("/bakerysales/savebinder", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    cekBinder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['customer_id', 'tanggal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerysales/cekbinder${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });  
    },
    deliverydetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['customer_id', 'tanggal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerycustomerdelivery/detail${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },        
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/bakerysales/detail/${obj.SaleHdrId}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingdetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['SaleHdrId', 'BinderId'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerysales/postingdetail${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
            let url ='';
            if(obj.option=='Lines'){
                url =`delete-sales-detail/${obj.SaleDtlId}`;
            }else if(obj.option=='Header'){
                url =`delete-sales-header/${obj.SaleHdrId}`;
            }else{
                url =`delete-sales-binder/${obj.BinderId}`;
            }

            const {data} = await axios.delete(`/bakerysales/${url}`);
            resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    } ,   
    print(obj,withvalue) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/bakerysales/print?SaleHdrId=${obj.SaleHdrId}&withvalue=${withvalue}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printInv(obj,withvalue) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/arinv/print?key=${obj.SaleHdrId}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    export(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                 const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'salesae_name', 'salesae_id', 'CustName', 'customer_id', 'customer_group', 'nomor', 'tgl1', 'tgl2',  'status', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
        
                const response = axios({
                    url: `/bakerysales/export${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                resolve(response);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    listbinderexport(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                 const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'salesae_name', 'salesae_id', 'CustName', 'customer_id', 'customer_group', 'nomor', 'tgl1', 'tgl2',  'status', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
        
                const response = axios({
                    url: `/bakerysales/listbinderexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                resolve(response);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    listlineexport(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                 const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'salesae_name', 'salesae_id', 'CustName', 'customer_id', 'customer_group', 'nomor', 'tgl1', 'tgl2',  'status', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
        
                const response = axios({
                    url: `/bakerysales/listlineexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                resolve(response);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}